import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui/UiButton';
import { Icon, Input } from 'shared/ui';
import { TaskFilters as Filters, ChangeTaskFilter } from 'entities/task';

import cls from './ProjectsFilter.module.css';
import { useProjectsFilter } from '../../lib/hooks/useProjectsFilter';
import { SelectedFilter } from '../../lib/hooks/useTaskExtraFilters';

interface ProjectsFilterProps {
    classes?: string;
    isShow: boolean;
    onSelectedFilter: (value: SelectedFilter) => void;
    onFilteredData: ChangeTaskFilter;
    filteredData: Filters;
}

export const ProjectsFilter = memo(
    ({
        classes,
        onSelectedFilter,
        isShow,
        onFilteredData,
        filteredData,
    }: ProjectsFilterProps) => {
        const {
            selectedItem,
            changeSelectedItem,
            projectAndEstimates,
            resetButton,
            onInput,
            input,
            resetIconButton,
        } = useProjectsFilter(onFilteredData, filteredData);

        const { t } = useTranslation();

        return (
            <div
                className={classNames(cls.ProjectsFilter, [classes], {
                    [cls.open]: isShow,
                })}
            >
                <div
                    className={classNames(cls.header)}
                    onClick={() => onSelectedFilter(isShow ? null : 'project')}
                >
                    <div className={cls.iconWrapper}>
                        <Icon iconName="taskProjects" />
                    </div>
                    {selectedItem ? (
                        <div className={cls.selectedItem}>
                            <span>{selectedItem.title}</span>
                        </div>
                    ) : (
                        <div className={cls.placeholder}>
                            {t('ProjectsFilter.return.ProjectsFilter.placeholder')}
                        </div>
                    )}
                    {selectedItem ? (
                        <UiButton
                            onClick={resetIconButton}
                            className={cls.resetIcon}
                            variant="icon"
                            startIcon={<Icon iconName="resetInput" />}
                        />
                    ) : (
                        <div
                            className={classNames(cls.arrow, {
                                [cls.openArrow]: isShow,
                            })}
                        >
                            <Icon iconName="selectArrow" />
                        </div>
                    )}
                </div>
                <div className={classNames(cls.select)}>
                    <Input classes={[cls.input]} value={input} onValueChange={onInput} />
                    <div
                        onClick={() => resetButton()}
                        className={classNames(cls.filterItem, cls.notSelected)}
                    >
                        <span>{t('SearchSelectWithSubList.return.not_selected')}</span>
                    </div>
                    {projectAndEstimates.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => changeSelectedItem(item)}
                            className={classNames(cls.filterItem, {
                                [cls.estimate]: !item.isProject,
                                [cls.project]: item.isProject,
                                [cls.active]: item.id === selectedItem?.id,
                            })}
                        >
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
);
